/* tslint:disable */
/* eslint-disable */
/**
 * Capture config API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, setBearerAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, BaseAPI, operationServerMap } from '../base';
/**
 * UserApi - axios parameter creator
 */
export const UserApiAxiosParamCreator = function (configuration) {
    return {
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Creates a User
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {UserViewModel} [userViewModel]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUser: async (authorization, authVersion, companyView, userViewModel, options = {}) => {
            const localVarPath = `/v1/User/CreateUser`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json; X-Api-Version=1.0';
            localVarHeaderParameter['Accept'] = 'text/plain; X-Api-Version=1.0,application/json; X-Api-Version=1.0,text/json; X-Api-Version=1.0';
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (authVersion != null) {
                localVarHeaderParameter['AuthVersion'] = String(authVersion);
            }
            if (companyView != null) {
                localVarHeaderParameter['CompanyView'] = String(companyView);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(userViewModel, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Removes a user by id
         * @param {number} [id]
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUser: async (id, authorization, authVersion, companyView, options = {}) => {
            const localVarPath = `/v1/User/DeleteUser`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            localVarHeaderParameter['Accept'] = 'text/plain; X-Api-Version=1.0,application/json; X-Api-Version=1.0,text/json; X-Api-Version=1.0';
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (authVersion != null) {
                localVarHeaderParameter['AuthVersion'] = String(authVersion);
            }
            if (companyView != null) {
                localVarHeaderParameter['CompanyView'] = String(companyView);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Returns all users
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllUsers: async (authorization, authVersion, companyView, options = {}) => {
            const localVarPath = `/v1/User/GetAllUsers`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Accept'] = 'text/plain; X-Api-Version=1.0,application/json; X-Api-Version=1.0,text/json; X-Api-Version=1.0';
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (authVersion != null) {
                localVarHeaderParameter['AuthVersion'] = String(authVersion);
            }
            if (companyView != null) {
                localVarHeaderParameter['CompanyView'] = String(companyView);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Returns all users with extra detail info
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllUsersAsTable: async (authorization, authVersion, companyView, options = {}) => {
            const localVarPath = `/v1/User/GetAllUsersAsTable`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Accept'] = 'text/plain; X-Api-Version=1.0,application/json; X-Api-Version=1.0,text/json; X-Api-Version=1.0';
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (authVersion != null) {
                localVarHeaderParameter['AuthVersion'] = String(authVersion);
            }
            if (companyView != null) {
                localVarHeaderParameter['CompanyView'] = String(companyView);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Returns all users with extra detail info
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllUsersForDashboardPermissions: async (authorization, authVersion, companyView, options = {}) => {
            const localVarPath = `/v1/User/GetAllUsersForDashboardPermissions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Accept'] = 'text/plain; X-Api-Version=1.0,application/json; X-Api-Version=1.0,text/json; X-Api-Version=1.0';
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (authVersion != null) {
                localVarHeaderParameter['AuthVersion'] = String(authVersion);
            }
            if (companyView != null) {
                localVarHeaderParameter['CompanyView'] = String(companyView);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Returns a user by id
         * @param {number} [id]
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserById: async (id, authorization, authVersion, companyView, options = {}) => {
            const localVarPath = `/v1/User/GetUserById`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            localVarHeaderParameter['Accept'] = 'text/plain; X-Api-Version=1.0,application/json; X-Api-Version=1.0,text/json; X-Api-Version=1.0';
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (authVersion != null) {
                localVarHeaderParameter['AuthVersion'] = String(authVersion);
            }
            if (companyView != null) {
                localVarHeaderParameter['CompanyView'] = String(companyView);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Returns a user by name
         * @param {string} [name]
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserByName: async (name, authorization, authVersion, companyView, options = {}) => {
            const localVarPath = `/v1/User/GetUserByName`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (name !== undefined) {
                localVarQueryParameter['Name'] = name;
            }
            localVarHeaderParameter['Accept'] = 'text/plain; X-Api-Version=1.0,application/json; X-Api-Version=1.0,text/json; X-Api-Version=1.0';
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (authVersion != null) {
                localVarHeaderParameter['AuthVersion'] = String(authVersion);
            }
            if (companyView != null) {
                localVarHeaderParameter['CompanyView'] = String(companyView);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Returns users by company ID
         * @param {number} [id]
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsersByCompanyId: async (id, authorization, authVersion, companyView, options = {}) => {
            const localVarPath = `/v1/User/GetUsersByCompanyId`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            localVarHeaderParameter['Accept'] = 'text/plain; X-Api-Version=1.0,application/json; X-Api-Version=1.0,text/json; X-Api-Version=1.0';
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (authVersion != null) {
                localVarHeaderParameter['AuthVersion'] = String(authVersion);
            }
            if (companyView != null) {
                localVarHeaderParameter['CompanyView'] = String(companyView);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        me: async (authorization, authVersion, companyView, options = {}) => {
            const localVarPath = `/v1/User/Me`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            localVarHeaderParameter['Accept'] = 'text/plain; X-Api-Version=1.0,application/json; X-Api-Version=1.0,text/json; X-Api-Version=1.0';
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (authVersion != null) {
                localVarHeaderParameter['AuthVersion'] = String(authVersion);
            }
            if (companyView != null) {
                localVarHeaderParameter['CompanyView'] = String(companyView);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [id]
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resendInvite: async (id, authorization, authVersion, companyView, options = {}) => {
            const localVarPath = `/v1/User/ResendInvite`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            localVarHeaderParameter['Accept'] = 'text/plain; X-Api-Version=1.0,application/json; X-Api-Version=1.0,text/json; X-Api-Version=1.0';
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (authVersion != null) {
                localVarHeaderParameter['AuthVersion'] = String(authVersion);
            }
            if (companyView != null) {
                localVarHeaderParameter['CompanyView'] = String(companyView);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         *
         * @param {number} [id]
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetPassword: async (id, authorization, authVersion, companyView, options = {}) => {
            const localVarPath = `/v1/User/ResetPassword`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            localVarHeaderParameter['Accept'] = 'text/plain; X-Api-Version=1.0,application/json; X-Api-Version=1.0,text/json; X-Api-Version=1.0';
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (authVersion != null) {
                localVarHeaderParameter['AuthVersion'] = String(authVersion);
            }
            if (companyView != null) {
                localVarHeaderParameter['CompanyView'] = String(companyView);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Body format: application/x-www-form-urlencoded <br /><br />  Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Edit a user
         * @param {number} [id]
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {UserViewModel} [userViewModel]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userEdit: async (id, authorization, authVersion, companyView, userViewModel, options = {}) => {
            const localVarPath = `/v1/User/UserEdit`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (id !== undefined) {
                localVarQueryParameter['id'] = id;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json-patch+json; X-Api-Version=1.0';
            localVarHeaderParameter['Accept'] = 'text/plain; X-Api-Version=1.0,application/json; X-Api-Version=1.0,text/json; X-Api-Version=1.0';
            if (authorization != null) {
                localVarHeaderParameter['Authorization'] = String(authorization);
            }
            if (authVersion != null) {
                localVarHeaderParameter['AuthVersion'] = String(authVersion);
            }
            if (companyView != null) {
                localVarHeaderParameter['CompanyView'] = String(companyView);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            localVarRequestOptions.data = serializeDataIfNeeded(userViewModel, localVarRequestOptions, configuration);
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Returns the registration state for the specified user
         * @param {string} [username]
         * @param {string} [registerCode]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userRegisterState: async (username, registerCode, authVersion, companyView, options = {}) => {
            const localVarPath = `/v1/User/UserRegisterState`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            // authentication jwt_auth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration);
            if (username !== undefined) {
                localVarQueryParameter['username'] = username;
            }
            if (registerCode !== undefined) {
                localVarQueryParameter['registerCode'] = registerCode;
            }
            localVarHeaderParameter['Accept'] = 'text/plain; X-Api-Version=1.0,application/json; X-Api-Version=1.0,text/json; X-Api-Version=1.0';
            if (authVersion != null) {
                localVarHeaderParameter['AuthVersion'] = String(authVersion);
            }
            if (companyView != null) {
                localVarHeaderParameter['CompanyView'] = String(companyView);
            }
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
/**
 * UserApi - functional programming interface
 */
export const UserApiFp = function (configuration) {
    const localVarAxiosParamCreator = UserApiAxiosParamCreator(configuration);
    return {
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Creates a User
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {UserViewModel} [userViewModel]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createUser(authorization, authVersion, companyView, userViewModel, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createUser(authorization, authVersion, companyView, userViewModel, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.createUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Removes a user by id
         * @param {number} [id]
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteUser(id, authorization, authVersion, companyView, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteUser(id, authorization, authVersion, companyView, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.deleteUser']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Returns all users
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllUsers(authorization, authVersion, companyView, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllUsers(authorization, authVersion, companyView, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.getAllUsers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Returns all users with extra detail info
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllUsersAsTable(authorization, authVersion, companyView, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllUsersAsTable(authorization, authVersion, companyView, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.getAllUsersAsTable']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Returns all users with extra detail info
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllUsersForDashboardPermissions(authorization, authVersion, companyView, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllUsersForDashboardPermissions(authorization, authVersion, companyView, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.getAllUsersForDashboardPermissions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Returns a user by id
         * @param {number} [id]
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserById(id, authorization, authVersion, companyView, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserById(id, authorization, authVersion, companyView, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.getUserById']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Returns a user by name
         * @param {string} [name]
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserByName(name, authorization, authVersion, companyView, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserByName(name, authorization, authVersion, companyView, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.getUserByName']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Returns users by company ID
         * @param {number} [id]
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUsersByCompanyId(id, authorization, authVersion, companyView, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUsersByCompanyId(id, authorization, authVersion, companyView, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.getUsersByCompanyId']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async me(authorization, authVersion, companyView, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.me(authorization, authVersion, companyView, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.me']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [id]
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resendInvite(id, authorization, authVersion, companyView, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resendInvite(id, authorization, authVersion, companyView, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.resendInvite']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         *
         * @param {number} [id]
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async resetPassword(id, authorization, authVersion, companyView, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.resetPassword(id, authorization, authVersion, companyView, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.resetPassword']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Body format: application/x-www-form-urlencoded <br /><br />  Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Edit a user
         * @param {number} [id]
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {UserViewModel} [userViewModel]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userEdit(id, authorization, authVersion, companyView, userViewModel, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userEdit(id, authorization, authVersion, companyView, userViewModel, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.userEdit']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Returns the registration state for the specified user
         * @param {string} [username]
         * @param {string} [registerCode]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async userRegisterState(username, registerCode, authVersion, companyView, options) {
            const localVarAxiosArgs = await localVarAxiosParamCreator.userRegisterState(username, registerCode, authVersion, companyView, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserApi.userRegisterState']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    };
};
/**
 * UserApi - factory interface
 */
export const UserApiFactory = function (configuration, basePath, axios) {
    const localVarFp = UserApiFp(configuration);
    return {
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Creates a User
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {UserViewModel} [userViewModel]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createUser(authorization, authVersion, companyView, userViewModel, options) {
            return localVarFp.createUser(authorization, authVersion, companyView, userViewModel, options).then((request) => request(axios, basePath));
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Removes a user by id
         * @param {number} [id]
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteUser(id, authorization, authVersion, companyView, options) {
            return localVarFp.deleteUser(id, authorization, authVersion, companyView, options).then((request) => request(axios, basePath));
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Returns all users
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllUsers(authorization, authVersion, companyView, options) {
            return localVarFp.getAllUsers(authorization, authVersion, companyView, options).then((request) => request(axios, basePath));
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Returns all users with extra detail info
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllUsersAsTable(authorization, authVersion, companyView, options) {
            return localVarFp.getAllUsersAsTable(authorization, authVersion, companyView, options).then((request) => request(axios, basePath));
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Returns all users with extra detail info
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllUsersForDashboardPermissions(authorization, authVersion, companyView, options) {
            return localVarFp.getAllUsersForDashboardPermissions(authorization, authVersion, companyView, options).then((request) => request(axios, basePath));
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Returns a user by id
         * @param {number} [id]
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserById(id, authorization, authVersion, companyView, options) {
            return localVarFp.getUserById(id, authorization, authVersion, companyView, options).then((request) => request(axios, basePath));
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Returns a user by name
         * @param {string} [name]
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserByName(name, authorization, authVersion, companyView, options) {
            return localVarFp.getUserByName(name, authorization, authVersion, companyView, options).then((request) => request(axios, basePath));
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Returns users by company ID
         * @param {number} [id]
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUsersByCompanyId(id, authorization, authVersion, companyView, options) {
            return localVarFp.getUsersByCompanyId(id, authorization, authVersion, companyView, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        me(authorization, authVersion, companyView, options) {
            return localVarFp.me(authorization, authVersion, companyView, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [id]
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resendInvite(id, authorization, authVersion, companyView, options) {
            return localVarFp.resendInvite(id, authorization, authVersion, companyView, options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {number} [id]
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        resetPassword(id, authorization, authVersion, companyView, options) {
            return localVarFp.resetPassword(id, authorization, authVersion, companyView, options).then((request) => request(axios, basePath));
        },
        /**
         * Body format: application/x-www-form-urlencoded <br /><br />  Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Edit a user
         * @param {number} [id]
         * @param {string} [authorization]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {UserViewModel} [userViewModel]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userEdit(id, authorization, authVersion, companyView, userViewModel, options) {
            return localVarFp.userEdit(id, authorization, authVersion, companyView, userViewModel, options).then((request) => request(axios, basePath));
        },
        /**
         * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
         * @summary Returns the registration state for the specified user
         * @param {string} [username]
         * @param {string} [registerCode]
         * @param {string} [authVersion]
         * @param {string} [companyView]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        userRegisterState(username, registerCode, authVersion, companyView, options) {
            return localVarFp.userRegisterState(username, registerCode, authVersion, companyView, options).then((request) => request(axios, basePath));
        },
    };
};
/**
 * UserApi - object-oriented interface
 */
export class UserApi extends BaseAPI {
    /**
     * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
     * @summary Creates a User
     * @param {string} [authorization]
     * @param {string} [authVersion]
     * @param {string} [companyView]
     * @param {UserViewModel} [userViewModel]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createUser(authorization, authVersion, companyView, userViewModel, options) {
        return UserApiFp(this.configuration).createUser(authorization, authVersion, companyView, userViewModel, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
     * @summary Removes a user by id
     * @param {number} [id]
     * @param {string} [authorization]
     * @param {string} [authVersion]
     * @param {string} [companyView]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    deleteUser(id, authorization, authVersion, companyView, options) {
        return UserApiFp(this.configuration).deleteUser(id, authorization, authVersion, companyView, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
     * @summary Returns all users
     * @param {string} [authorization]
     * @param {string} [authVersion]
     * @param {string} [companyView]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAllUsers(authorization, authVersion, companyView, options) {
        return UserApiFp(this.configuration).getAllUsers(authorization, authVersion, companyView, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
     * @summary Returns all users with extra detail info
     * @param {string} [authorization]
     * @param {string} [authVersion]
     * @param {string} [companyView]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAllUsersAsTable(authorization, authVersion, companyView, options) {
        return UserApiFp(this.configuration).getAllUsersAsTable(authorization, authVersion, companyView, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
     * @summary Returns all users with extra detail info
     * @param {string} [authorization]
     * @param {string} [authVersion]
     * @param {string} [companyView]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getAllUsersForDashboardPermissions(authorization, authVersion, companyView, options) {
        return UserApiFp(this.configuration).getAllUsersForDashboardPermissions(authorization, authVersion, companyView, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
     * @summary Returns a user by id
     * @param {number} [id]
     * @param {string} [authorization]
     * @param {string} [authVersion]
     * @param {string} [companyView]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getUserById(id, authorization, authVersion, companyView, options) {
        return UserApiFp(this.configuration).getUserById(id, authorization, authVersion, companyView, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
     * @summary Returns a user by name
     * @param {string} [name]
     * @param {string} [authorization]
     * @param {string} [authVersion]
     * @param {string} [companyView]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getUserByName(name, authorization, authVersion, companyView, options) {
        return UserApiFp(this.configuration).getUserByName(name, authorization, authVersion, companyView, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
     * @summary Returns users by company ID
     * @param {number} [id]
     * @param {string} [authorization]
     * @param {string} [authVersion]
     * @param {string} [companyView]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getUsersByCompanyId(id, authorization, authVersion, companyView, options) {
        return UserApiFp(this.configuration).getUsersByCompanyId(id, authorization, authVersion, companyView, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {string} [authorization]
     * @param {string} [authVersion]
     * @param {string} [companyView]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    me(authorization, authVersion, companyView, options) {
        return UserApiFp(this.configuration).me(authorization, authVersion, companyView, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [id]
     * @param {string} [authorization]
     * @param {string} [authVersion]
     * @param {string} [companyView]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    resendInvite(id, authorization, authVersion, companyView, options) {
        return UserApiFp(this.configuration).resendInvite(id, authorization, authVersion, companyView, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {number} [id]
     * @param {string} [authorization]
     * @param {string} [authVersion]
     * @param {string} [companyView]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    resetPassword(id, authorization, authVersion, companyView, options) {
        return UserApiFp(this.configuration).resetPassword(id, authorization, authVersion, companyView, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Body format: application/x-www-form-urlencoded <br /><br />  Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
     * @summary Edit a user
     * @param {number} [id]
     * @param {string} [authorization]
     * @param {string} [authVersion]
     * @param {string} [companyView]
     * @param {UserViewModel} [userViewModel]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userEdit(id, authorization, authVersion, companyView, userViewModel, options) {
        return UserApiFp(this.configuration).userEdit(id, authorization, authVersion, companyView, userViewModel, options).then((request) => request(this.axios, this.basePath));
    }
    /**
     * Authorization header format: Bearer -token- <br /><br />  CompanyView header is optional => changes the point of view to a subcompany
     * @summary Returns the registration state for the specified user
     * @param {string} [username]
     * @param {string} [registerCode]
     * @param {string} [authVersion]
     * @param {string} [companyView]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    userRegisterState(username, registerCode, authVersion, companyView, options) {
        return UserApiFp(this.configuration).userRegisterState(username, registerCode, authVersion, companyView, options).then((request) => request(this.axios, this.basePath));
    }
}
